import Supercluster from 'supercluster';

class MapCluster {
    constructor() {
        this.cluster = new Supercluster({
            // log: true,
            extent: 128,
            maxZoom: 13
        });
    }


    get() {
        return this.cluster;
    }
}

const mapCluster = new MapCluster();

Object.freeze(mapCluster);


export {mapCluster};
